// Preload a brand font that only some pages render (the site-wide ones are preloaded in nuxt.config).
export function usePreloadFont(file: string) {
  useHead({
    link: [{ rel: 'preload', as: 'font', type: 'font/woff2', href: `/fonts/${file}.woff2`, crossorigin: '' }],
  })
}
